import React from "react";

// @ts-ignore
const DialogContext = React.createContext();

export default DialogContext;
